
.container {
  border-radius: 12px;
  border: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
  box-shadow: 0 0 0 4px var(--static-background-weak, #fafafa) inset;
  background: var(--static-background-standard, #fff);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  min-width: fit-content;
  min-height: fit-content;
  max-width: fit-content;
  max-height: fit-content;
  flex-shrink: 0;
}

.styledImage {
  border-radius: 8px;
}
